import fetch from "../components/optionsFetch";
import * as React from "react";
import Notifications from '../components/Notifications';
import AdvancedSearchNotice from '../components/AdvancedSearchNotice';
import DataGrid from "../components/DataGrid";
import GetColumnDefs from "../components/ColumnDefs";
import { Button } from "@progress/kendo-react-buttons";
import { TextBox } from "@progress/kendo-react-inputs";
import { MultiSelect, DropDownList } from "@progress/kendo-react-dropdowns";
import configData from "../config.json";
import { GetSession, GetToken } from '../components/Session';
import { GetPermissions } from '../components/Options';
import { ExpansionPanel, ExpansionPanelContent } from "@progress/kendo-react-layout";
import { Reveal } from "@progress/kendo-react-animation";
import { useNavigate } from "react-router-dom";
import { filterBy } from "@progress/kendo-data-query";
import { getMultiSelectTreeValue } from "@progress/kendo-react-dropdowns";
import { processMultiSelectTreeData, expandedState } from "../components/multiselecttree-data-operations";
import { MultiSelectTreeEditor } from "../components/MultiSelectTreeEditor";

const Trucks = () => {
  const [lookupParams, setLookupParams] = React.useState("");
  const [loadTypes, setLoadTypes] = React.useState([]);
  const [loadType, setLoadType] = React.useState([]);
  const [rego, setRego] = React.useState("");
  const [code, setCode] = React.useState("");
  const [fleet, setFleet] = React.useState("");
  const [tagId, setTagId] = React.useState("");
  const [vehicleType, setVehicleType] = React.useState();
  const [jobs, setJobs] = React.useState([]);
  const [job, setJob] = React.useState([]);
  const [customers, setCustomers] = React.useState([]);
  const [customer, setCustomer] = React.useState([]);
  const [sources, setSources] = React.useState([]);
  const [source, setSource] = React.useState([]);
  const [destinations, setDestinations] = React.useState([]);
  const [destination, setDestination] = React.useState([]);
  const [sites, setSites] = React.useState([]);
  const [site, setSite] = React.useState([]);
  const [products, setProducts] = React.useState([]);
  const [product, setProduct] = React.useState([]);
  const [truckConfigs, setTruckConfigs] = React.useState([]);
  const [truckConfig, setTruckConfig] = React.useState([]);
  const [directions, setDirections] = React.useState([]);
  const [direction, setDirection] = React.useState();
  const [truckTrailers, setTruckTrailers] = React.useState([]);
  const [truckTrailer, setTruckTrailer] = React.useState();
  const [statii, setStatii] = React.useState([]);
  const [status, setStatus] = React.useState();
  const [expanded, setExpanded] = React.useState(false);
  const [filtersApplied, setFiltersApplied] = React.useState(() => Boolean(localStorage.getItem("TruckSearch")));
  const ready = React.useRef(false);
  const [columns, setColumns] = React.useState(null);
  const [errorMessage, setErrorMessage] = React.useState("");
  const [permissions, setPermissions] = React.useState(null);
  const [productdata, setproductData] = React.useState();
  const [customerdata, setcustomerData] = React.useState();
  const [jobdata, setjobData] = React.useState(); 
  const [truckconfdata, settruckconfData] = React.useState();
  const [destdata, setdestData] = React.useState();
  const [srcdata, setsrcData] = React.useState();
  const [forceUpdate, setForceUpdate] = React.useState("");
  const options = React.useRef();
  const navigate = useNavigate();
  if (permissions && !permissions.CanView) navigate("/error401");
  if (localStorage.getItem("userid") === null) navigate("/logout");
  let ts = localStorage.getItem("TruckSearch");


  const [layout, setLayout] = React.useState([
    { "field": "searchAdvanced", "label": "Advanced Search", "isVisible": true, },
    { "field": "searchRego", "label": "Rego", "isVisible": true, }, 
    { "field": "searchCode", "label": "Code", "isVisible": true, }, 
    { "field": "searchFleet", "label": "Fleet", "isVisible": true, },
    { "field": "searchLoadType", "label": "Load Type", "isVisible": true, }, 
    { "field": "searchVehicletype", "label": "Vehicle Type", "isVisible": true, }, 
    { "field": "searchJob", "label": "Job", "isVisible": true, }, 
    { "field": "searchCustomer", "label": "Customer", "isVisible": true, }, 
    { "field": "searchSource", "label": "Source", "isVisible": true, }, 
    { "field": "searchDestination", "label": "Destination", "isVisible": true, }, 
    { "field": "searchSite", "label": "Site", "isVisible": true, }, 
    { "field": "searchProduct", "label": "Product", "isVisible": true, }, 
    { "field": "searchTruckConfig", "label": "Truck Config", "isVisible": true, }, 
    { "field": "searchDirection", "label": "Direction", "isVisible": true, }, 
    { "field": "searchStatus", "label": "Status", "isVisible": true, }, 
    { "field": "searchTruckTrailer", "label": "Truck/Trailer", "isVisible": true, }, 
    { "field": "searchTagId", "label": "Tag ID", "isVisible": true, }  
  ]);

  const subTotals = [
    { field: 'tare1', aggregate: 'average' },
    { field: 'tare1', aggregate: 'average' },
    { field: 'tare3', aggregate: 'average' },
    { field: 'tare4', aggregate: 'average' },
    { field: 'tare5', aggregate: 'average' },
    { field: 'tare', aggregate: 'sum' },
    { field: 'maxLoad', aggregate: 'sum' },
    { field: 'maxLoadWarnings', aggregate: 'sum' },
    { field: 'percentOverloadWarnings', aggregate: 'sum' },
    { field: 'majorOverloadWarnings', aggregate: 'sum' },
    { field: 'severOverloadWarnings', aggregate: 'sum' },
  ];

  const GetField = (f) => {
    return layout.find(obj => { return obj.field === f });
  }

  const DoSearch = () => {
    var truckParam = {
      Name: rego,
      Code: code,
      Fleet: fleet,
      LoadType: loadType === undefined ? "0" : GetLoadTypes(loadType),
      Vehicle: GetIds(vehicleTypesValue),
      Job: GetIds(jobsValue),
      Customer: GetIds(customersValue),
      Source: GetIds(sourcesValue),
      Destination: GetIds(destinationsValue),
      Site: GetIds(sitesValue),
      Product: GetIds(productsValue),
      TruckConfig: GetIds(truckConfigsValue),
      Direction: direction,
      Status: status,
      Trucktrailer: truckTrailer,
      TagId: tagId,
    };
    setLookupParams(encodeURI(JSON.stringify(truckParam)));
    localStorage.setItem("TruckSearch", JSON.stringify(truckParam));
    setFiltersApplied(true);
  };

    const GetIds = (d) => {
        if (d === null || d === undefined || d.length === undefined || d.length === 0) return "0";
        let r = "";
        d.map(x => {
            r += (r.length > 0 ? ";" : "") + x.id;
        });
        return r;
    }

    const GetLoadTypes = (loadType) => {
        if (loadType === "" || loadType === undefined) return "";
        let r = "";
        loadType.map(x => {
            r += (r.length > 0 ? ";" : "") + x;
        })
        return r;
    }

  const ClearSearch = () => {
    setFiltersApplied(false);
    if (ready.current) {
      ClearParams();
        var truckParam = {
        Name: "",
        Code: "",
        Fleet: "",
        LoadType: "",
        Vehicle: "",
        Job: "",
        Customer: "",
        Source: "",
        Destination: "",
        Site: "",
        Product: "",
        TruckConfig: "",
        Direction: "All",
        Status: "Active",
        Trucktrailer: "All",
        TagId: ""
      };
      setLookupParams(encodeURI(JSON.stringify(truckParam)));
      localStorage.removeItem("TruckSearch");
    }
  };

  const ClearParams = () => {
    setRego("");
    setCode("");
    setFleet("");
    setLoadType([]);
    setVehicleTypesValue([]);
    setJobsValue([]);
    setCustomersValue([]);
    setSourcesValue([]);
    setDestinationsValue([]);
    setSitesValue([]);
    setProductsValue([]);
    setTruckConfigsValue([]);
    setDirection("All");
    setTruckTrailer("All");
    setStatus("Active");
    setTagId("");
    };

  const loadTypeChanged = (event) => {
    setLoadType(event.target.value);
  };
  const vehicleTypeChanged = (event) => {
    setVehicleType(event.target.value);
  };
  const jobChanged = (event) => {
    setJob(event.target.value);
  };
  const customerChanged = (event) => {
    setCustomer(event.target.value);
  };
  const sourceChanged = (event) => {
    setSource(event.target.value);
  };
  const destinationChanged = (event) => {
    setDestination(event.target.value);
  };
  const siteChanged = (event) => {
    setSite(event.target.value);
  };
  const productChanged = (event) => {
    setProduct(event.target.value);
  };
  const truckConfigChanged = (event) => {
    setTruckConfig(event.target.value);
  };
  const directionChanged = (event) => {
    setDirection(event.target.value);
  };
  const statusChanged = (event) => {
    setStatus(event.target.value);
  };
  const truckTrailerChanged = (event) => {
    setTruckTrailer(event.target.value);
  };

  React.useEffect(() => {
    GetColumnDefs("trucks", setColumns, setErrorMessage); 
    GetPermissions(["ViewTruck", "NewTruck", "EditTruck", "DeleteTruck", "ReportTruck"], setPermissions)
    let baseUrl = configData.SERVER_URL + "apiv7/userinterfaces?$filter=viewName eq 'Trucks'";
    const init = {
      method: "GET",
      accept: "application/json",
      headers: {"Authorization": "Bearer " + GetToken()},
    };
    fetch(baseUrl, init).then(response => response.json()).then(d => { 
      if (GetSession().IsMobile){
          let data = [];
          for(let i = 0; i < d.length; i++){
              data.push({field: d[i].field, label: d[i].label, type:d[i].type, format: d[i].format, isVisible: d[i].isVisible && d[i].isVisibleOnMobile});
          }
          setLayout(data);
      } else {
          setLayout(d); 
      }
    });  
    baseUrl = configData.SERVER_URL + "apiv7/options";
    fetch(baseUrl, init)
      .then((response) => response.json())
        .then((d) => {
        options.current = d;
        setLoadTypes(d.loadTypes);
        ConfigureJobs(d.jobs);
        ConfigureProducts(d.products);
        ConfigureCustomers(d.customers);
        ConfigureDestinations(d.destinations);
        ConfigureSources(d.sources);
        ConfigureSites(d.sites);
        ConfigureTruckConfigs(d.vehicleConfigurations);
        ConfigureVehicleTypes(d.vehicles);
        setDirections(d.allDirections);
        setTruckTrailers(d.truckTrailer);
        setStatii(d.status);
        if (ts !== undefined && ts !== "" && ts !== null) {
            setTimeout(() => { UpdateSavedParams() }, 100);
        } else {
            ClearParams();
        }
        ready.current = true;
      });
  }, []);

    const UpdateSavedParams = () => {
        if (ts === undefined) return;
        let def = JSON.parse(ts);
        setRego(def.Name || "");
        setCode(def.Code || "");
        setFleet(def.Fleet || "");
        setTagId(def.TagId || "");
        let st = GetSelected(options.current.sites, def.Site);
        if (st !== undefined && st[0] === undefined) st = [];
        setSitesValue(st);
        let src = GetSelected(options.current.sources, def.Source);
        if (src !== undefined && src[0] === undefined) src = [];
        setSourcesValue(src);
        let dst = GetSelected(options.current.destinations, def.Destination);
        if (dst !== undefined && dst[0] === undefined) dst = [];
        setDestinationsValue(dst);
        let lt = def.LoadType ? def.LoadType.split(';') : [];
        if (lt !== undefined && lt[0] === '') lt = [];
        setLoadType(lt);
        let vt = GetSelected(options.current.vehicles, def.Vehicle);
        if (vt !== undefined && vt[0] === undefined) vt = [];
        setVehicleTypesValue(vt);
        let jb = GetSelected(options.current.jobs, def.Job);
        if (jb !== undefined && jb[0] === undefined) jb = [];
        setJobsValue(jb);
        let cs = GetSelected(options.current.customers, def.Customer);
        if (cs !== undefined && cs[0] === undefined) cs = [];
        setCustomersValue(cs);
        let pr = GetSelected(options.current.products, def.Product);
        if (pr !== undefined && pr[0] === undefined) pr = [];
        setProductsValue(pr);
        let tc = GetSelected(options.current.vehicleConfigurations, def.TruckConfig);
        if (tc !== undefined && tc[0] === undefined) tc = [];
        setTruckConfigsValue(tc);
        setDirection(def.Direction);
        setTruckTrailer(def.Trucktrailer);
        setStatus(def.Status);
        var truckParam = {
            Name: def.Name,
            Code: def.Code,
            Fleet: def.Fleet,
            LoadType: def.LoadType,
            Vehicle: GetIds(vt),
            Job: GetIds(jb),
            Customer: GetIds(cs),
            Source: GetIds(src),
            Destination: GetIds(dst),
            Site: GetIds(st),
            Product: GetIds(pr),
            TruckConfig: GetIds(tc),
            Direction: def.Direction,
            Status: def.Status,
            Trucktrailer: def.Trucktrailer,
            TagId: def.TagId
        };
        setLookupParams(encodeURI(JSON.stringify(truckParam)));
    }

    const GetSelected = (c, d) => {
        let r = [];
        if (d === undefined || d === null || d === "0") return r;
        let sp = d.split(';');
        sp.forEach(s => {
            let f = c.find(obj => { return obj.id === s });
            if (f !== undefined) r.push({ id: f.id, text: f.name });
        });
        return r;
    }

    const filterproductData = (filter) => {
        const productdata = products.slice();
        return filterBy(productdata, filter);
    };
    const filterprodChange = (event) => {
        setproductData(filterproductData(event.filter));
    };

    const filterjobtData = (filter) => {
        const jobdata = jobs.slice();
        return filterBy(jobdata, filter);
    };
    const filterjobChange = (event) => {
        setjobData(filterjobtData(event.filter));
    };

    const filtercustomerData = (filter) => {
        const customerdata = customers.slice();
        return filterBy(customerdata, filter);
    };
    const filtercustChange = (event) => {
        setcustomerData(filtercustomerData(event.filter));
    };
    const filterdesData = (filter) => {
        const desdata = destinations.slice();
        return filterBy(desdata, filter);
    };
    const filterdesChange = (event) => {
        setdestData(filterdesData(event.filter));
    };

    const filtersrctData = (filter) => {
        const srcdata = sources.slice();
        return filterBy(srcdata, filter);
    };
    const filtersrcChange = (event) => {
        setsrcData(filtersrctData(event.filter));
    };

    const filtertruckconfData = (filter) => {
        const truckconfdata = truckConfigs.slice();
        return filterBy(truckconfdata, filter);
    };
    const filtertruckconfChange = (event) => {
        settruckconfData(filtertruckconfData(event.filter));
    };

    const filtersiteData = (filter) => {
        const sitedata = sites.slice();
        return filterBy(sitedata, filter);
    };
    const filtersiteChange = (event) => {
        setSitesData(filtersiteData(event.filter));
    };

    const onKeyDown = (ev) => {
        ev.stopPropagation();
    };

    const BulkStatus = (rec, st) => {
        let url = configData.SERVER_URL + `apiv7/trucks?truckList=${rec}&status=${st}`;
        const init = {
            method: 'PATCH',
            accept: 'application/json',
            headers: { "Authorization": "Bearer " + GetToken() }
        }
        fetch(url, init).then(response => {
            setForceUpdate(new Date());
        });
    }

    const dataItemKey = "id";
    const checkField = "checkField";
    const checkIndeterminateField = "checkIndeterminateField";
    const subItemsField = "items";
    const expandField = "expanded";
    const textField = "text";
    const fields = { dataItemKey, checkField, checkIndeterminateField, expandField, subItemsField };

    const GetConfigData = (act) => {
        let sl = [];
        let selected = [];
        for (let i = 0; i < act.length; i++) {
            let entry = { text: act[i].name, id: act[i].id };
            sl.push(entry);
            selected.push(entry);
        }
        let active = { id: 0, text: 'All', items: sl };
        return { active: active, selected: selected };
    }

    // state data for PRODUCT multi-select tree   
    const [productsData, setProductsData] = React.useState([{ id: 0, text: "All", items: [] }]);
    const [productsValue, setProductsValue] = React.useState([]);
    const [productExpanded, setProductExpanded] = React.useState([]);
    const onProductsChange = (event) => {
        setProductsValue(getMultiSelectTreeValue(productsData, { ...fields, ...event, value: productsValue, }));
    }
    const onProductsExpandChange = React.useCallback((event) => setProductExpanded(expandedState(event.item, dataItemKey, productExpanded)), [productExpanded]);
    const productsTreeData = React.useMemo(() =>
        processMultiSelectTreeData(productsData, { expanded: productExpanded, value: productsValue, ...fields }), [productsData, productExpanded, productsValue]
    );
    const ConfigureProducts = (act) => {
        let x = GetConfigData(act);
        setProductsData([x.active]);
        return [];
    }
    const ProductChanged = (event) => {
        let v = null;
        if (event.value !== null) v = event.value.filter((n) => { return n.id !== 0 });
        setProductsValue(v);
    };

    // state data for JOB multi-select tree   
    const [jobsData, setJobsData] = React.useState([{ id: 0, text: "All", items: [] }]);
    const [jobsValue, setJobsValue] = React.useState([]);
    const [jobExpanded, setJobExpanded] = React.useState([]);
    const onJobsChange = (event) => {
        setJobsValue(getMultiSelectTreeValue(jobsData, { ...fields, ...event, value: jobsValue, }));
    }
    const onjobsExpandChange = React.useCallback((event) => setJobExpanded(expandedState(event.item, dataItemKey, jobExpanded)), [jobExpanded]);
    const jobsTreeData = React.useMemo(() =>
        processMultiSelectTreeData(jobsData, { expanded: jobExpanded, value: jobsValue, ...fields }), [jobsData, jobExpanded, jobsValue]
    );
    const ConfigureJobs = (act) => {
        let x = GetConfigData(act);
        setJobsData([x.active]);
        return [];
    }
    const JobChanged = (event) => {
        let v = null;
        if (event.value !== null) v = event.value.filter((n) => { return n.id !== 0 });
        setJobsValue(v);
    };

    // state data for CUSTOMER multi-select tree   
    const [customersData, setCustomersData] = React.useState([{ id: 0, text: "All", items: [] }]);
    const [customersValue, setCustomersValue] = React.useState([]);
    const [customerExpanded, setCustomerExpanded] = React.useState([]);
    const onCustomersChange = (event) => {
        setCustomersValue(getMultiSelectTreeValue(customersData, { ...fields, ...event, value: customersValue, }));
    }
    const oncustomersExpandChange = React.useCallback((event) => setCustomerExpanded(expandedState(event.item, dataItemKey, customerExpanded)), [customerExpanded]);
    const customersTreeData = React.useMemo(() =>
        processMultiSelectTreeData(customersData, { expanded: customerExpanded, value: customersValue, ...fields }), [customersData, customerExpanded, customersValue]
    );
    const ConfigureCustomers = (act) => {
        let x = GetConfigData(act);
        setCustomersData([x.active]);
        return [];
    }
    const CustomerChanged = (event) => {
        let v = null;
        if (event.value !== null) v = event.value.filter((n) => { return n.id !== 0 });
        setCustomersValue(v);
    };

    // state data for source multi-select tree   
    const [sourcesData, setSourcesData] = React.useState([{ id: 0, text: "All", items: [] }]);
    const [sourcesValue, setSourcesValue] = React.useState([]);
    const [sourceExpanded, setSourceExpanded] = React.useState([]);
    const onSourcesChange = (event) => {
        setSourcesValue(getMultiSelectTreeValue(sourcesData, { ...fields, ...event, value: sourcesValue, }));
    }
    const onsourcesExpandChange = React.useCallback((event) => setSourceExpanded(expandedState(event.item, dataItemKey, sourceExpanded)), [sourceExpanded]);
    const sourcesTreeData = React.useMemo(() =>
        processMultiSelectTreeData(sourcesData, { expanded: sourceExpanded, value: sourcesValue, ...fields }), [sourcesData, sourceExpanded, sourcesValue]
    );
    const ConfigureSources = (act) => {
        let x = GetConfigData(act);
        setSourcesData([x.active]);
        return [];
    }
    const SourceChanged = (event) => {
        let v = null;
        if (event.value !== null) v = event.value.filter((n) => { return n.id !== 0 });
        setSourcesValue(v);
    };

    // state data for destination multi-select tree   
    const [destinationsData, setDestinationsData] = React.useState([{ id: 0, text: "All", items: [] }]);
    const [destinationsValue, setDestinationsValue] = React.useState([]);
    const [destinationExpanded, setDestinationExpanded] = React.useState([]);
    const onDestinationsChange = (event) => {
        setDestinationsValue(getMultiSelectTreeValue(destinationsData, { ...fields, ...event, value: destinationsValue, }));
    }
    const ondestinationsExpandChange = React.useCallback((event) => setDestinationExpanded(expandedState(event.item, dataItemKey, destinationExpanded)), [destinationExpanded]);
    const destinationsTreeData = React.useMemo(() =>
        processMultiSelectTreeData(destinationsData, { expanded: destinationExpanded, value: destinationsValue, ...fields }), [destinationsData, destinationExpanded, destinationsValue]
    );
    const ConfigureDestinations = (act) => {
        let x = GetConfigData(act);
        setDestinationsData([x.active]);
        return [];
    }
    const DestinationChanged = (event) => {
        let v = null;
        if (event.value !== null) v = event.value.filter((n) => { return n.id !== 0 });
        setDestinationsValue(v);
    };

    // state data for site multi-select tree   
    const [sitesData, setSitesData] = React.useState([{ id: 0, text: "All", items: [] }]);
    const [sitesValue, setSitesValue] = React.useState([]);
    const [siteExpanded, setSiteExpanded] = React.useState([]);
    const onSitesChange = (event) => {
        setSitesValue(getMultiSelectTreeValue(sitesData, { ...fields, ...event, value: sitesValue, }));
    }
    const onsitesExpandChange = React.useCallback((event) => setSiteExpanded(expandedState(event.item, dataItemKey, siteExpanded)), [siteExpanded]);
    const sitesTreeData = React.useMemo(() =>
        processMultiSelectTreeData(sitesData, { expanded: siteExpanded, value: sitesValue, ...fields }), [sitesData, siteExpanded, sitesValue]
    );
    const ConfigureSites = (act) => {
        let x = GetConfigData(act);
        setSitesData([x.active]);
        return [];
    }
    const SiteChanged = (event) => {
        let v = null;
        if (event.value !== null) v = event.value.filter((n) => { return n.id !== 0 });
        setSitesValue(v);
    };

    // state data for vehicleType multi-select tree   
    const [vehicleTypesData, setVehicleTypesData] = React.useState([{ id: 0, text: "All", items: [] }]);
    const [vehicleTypesValue, setVehicleTypesValue] = React.useState([]);
    const [vehicleTypeExpanded, setVehicleTypeExpanded] = React.useState([]);
    const onVehicleTypesChange = (event) => {
        setVehicleTypesValue(getMultiSelectTreeValue(vehicleTypesData, { ...fields, ...event, value: vehicleTypesValue, }));
    }
    const onvehicleTypesExpandChange = React.useCallback((event) => setVehicleTypeExpanded(expandedState(event.item, dataItemKey, vehicleTypeExpanded)), [vehicleTypeExpanded]);
    const vehicleTypesTreeData = React.useMemo(() =>
        processMultiSelectTreeData(vehicleTypesData, { expanded: vehicleTypeExpanded, value: vehicleTypesValue, ...fields }), [vehicleTypesData, vehicleTypeExpanded, vehicleTypesValue]
    );
    const ConfigureVehicleTypes = (act) => {
        let x = GetConfigData(act);
        setVehicleTypesData([x.active]);
        return [];
    }
    const VehicleTypeChanged = (event) => {
        let v = null;
        if (event.value !== null) v = event.value.filter((n) => { return n.id !== 0 });
        setVehicleTypesValue(v);
    };

    // state data for truckConfig multi-select tree   
    const [truckConfigsData, setTruckConfigsData] = React.useState([{ id: 0, text: "All", items: [] }]);
    const [truckConfigsValue, setTruckConfigsValue] = React.useState([]);
    const [truckConfigExpanded, setTruckConfigExpanded] = React.useState([]);
    const onTruckConfigsChange = (event) => {
        setTruckConfigsValue(getMultiSelectTreeValue(truckConfigsData, { ...fields, ...event, value: truckConfigsValue, }));
    }
    const ontruckConfigsExpandChange = React.useCallback((event) => setTruckConfigExpanded(expandedState(event.item, dataItemKey, truckConfigExpanded)), [truckConfigExpanded]);
    const truckConfigsTreeData = React.useMemo(() =>
        processMultiSelectTreeData(truckConfigsData, { expanded: truckConfigExpanded, value: truckConfigsValue, ...fields }), [truckConfigsData, truckConfigExpanded, truckConfigsValue]
    );
    const ConfigureTruckConfigs = (act) => {
        let x = GetConfigData(act);
        setTruckConfigsData([x.active]);
        return [];
    }
    const TruckConfigChanged = (event) => {
        let v = null;
        if (event.value !== null) v = event.value.filter((n) => { return n.id !== 0 });
        setTruckConfigsValue(v);
    };

  return (
    <div>
      <Notifications errorMessage={errorMessage}/>
      {GetField("searchAdvanced")["isVisible"] && <ExpansionPanel
        className="wm-advanced-search wm-advanced-search--kendo"
        title={GetField("searchAdvanced")["label"]}
        subtitle={filtersApplied ? <AdvancedSearchNotice active={filtersApplied} /> : null}
        expandIcon="fa fa-plus"
        collapseIcon="fa fa-minus"
        expanded={expanded}
        onAction={(e) => setExpanded(!e.expanded)}
      >
      <Reveal className="revealz">
          {expanded && (
            <ExpansionPanelContent>
            <div className="row" style={{ padding: "5px 10px" }} onKeyDown={onKeyDown}>
              {GetField("searchRego")["isVisible"] && <div className="col-md-2">
                  <label className="control-label">{GetField("searchRego")["label"]}</label>
                  <TextBox id="Rego" type="text" value={rego} onChange={(event) => setRego(event.target.value)} placeholder="Enter registration" />
                </div>}
                {GetField("searchCode")["isVisible"] && <div className="col-md-2">
                  <label className="control-label">{GetField("searchCode")["label"]}</label>
                  <TextBox id="Code" type="text" value={code} onChange={(event) => setCode(event.target.value)} placeholder="Enter code" />
                              </div>}                              
                {GetField("searchLoadType")["isVisible"] && <div className="col-md-2">
                  <label className="control-label">{GetField("searchLoadType")["label"]}</label>
                  <MultiSelect
                    id="LoadType"
                    data={loadTypes}
                    value={loadType}
                    onChange={loadTypeChanged}
                    placeholder="Select load type"
                  />
                </div>}
                  {GetField("searchVehicletype")["isVisible"] && <div className="col-md-2 MSTree">
                  <label className="control-label">{GetField("searchVehicletype")["label"]}</label>
                  <MultiSelectTreeEditor name={"vehicleType"} data={vehicleTypesTreeData} value={vehicleTypesValue} dataItemKey={dataItemKey} checkField={checkField} size="large" onChange={VehicleTypeChanged} textField="name" dataItemKey="id" filterable={true} onFilterChange={vehicleTypeChanged} placeholder="Select vehicle type" />
                </div>}
                    {GetField("searchJob")["isVisible"] && <div className="col-md-2 MSTree">
                    <label className="control-label">{GetField("searchJob")["label"]}</label>
                    <MultiSelectTreeEditor name={"Job"} data={jobsTreeData} value={jobsValue} dataItemKey={dataItemKey} checkField={checkField} size="large" onChange={JobChanged} textField="name" dataItemKey="id" filterable={true} onFilterChange={filterjobChange} placeholder="Select job" />
                </div>}
              </div>
              <div className="row" style={{ padding: "5px 10px" }}>
                
                {GetField("searchCustomer")["isVisible"] && <div className="col-md-2 MSTree">
                  <label className="control-label">{GetField("searchCustomer")["label"]}</label>
                  <MultiSelectTreeEditor name={"customerId"} data={customersTreeData} value={customersValue} dataItemKey={dataItemKey} checkField={checkField} size="large" onChange={CustomerChanged} textField="name" dataItemKey="id" filterable={true} onFilterChange={filtercustChange} placeholder="Select customer" />
                </div>}
                {GetField("searchSource")["isVisible"] && <div className="col-md-2 MSTree">
                  <label className="control-label">{GetField("searchSource")["label"]}</label>
                  <MultiSelectTreeEditor name={"Source"} data={sourcesTreeData} value={sourcesValue} dataItemKey={dataItemKey} checkField={checkField} size="large" onChange={SourceChanged} textField="name" dataItemKey="id" filterable={true} onFilterChange={filtersrcChange} placeholder="Select source" />
                </div>}
                {GetField("searchDestination")["isVisible"] && <div className="col-md-2 MSTree">
                  <label className="control-label">{GetField("searchDestination")["label"]}</label>
                    <MultiSelectTreeEditor name={"destination"} data={destinationsTreeData} value={destinationsValue} dataItemKey={dataItemKey} checkField={checkField} size="large" onChange={DestinationChanged} textField="name" dataItemKey="id" filterable={true} onFilterChange={filterdesChange} placeholder="Select destination" />
                </div>}
                {GetField("searchSite")["isVisible"] && <div className="col-md-2 MSTree">
                    <label className="control-label">{GetField("searchSite")["label"]}</label>
                    <MultiSelectTreeEditor name={"siteId"} data={sitesTreeData} value={sitesValue} dataItemKey={dataItemKey} checkField={checkField} size="large" onChange={SiteChanged} textField="name" dataItemKey="id" filterable={true} onFilterChange={filtersiteChange} placeholder="Select site" />
                </div>}
                {GetField("searchProduct")["isVisible"] && <div className="col-md-2 MSTree">
                    <label className="control-label">{GetField("searchProduct")["label"]}</label>
                    <MultiSelectTreeEditor name={"productId"} data={productsTreeData} value={productsValue} dataItemKey={dataItemKey} checkField={checkField} size="large" onChange={ProductChanged} textField="name" dataItemKey="id" filterable={true} onFilterChange={filterprodChange} placeholder="Select product" />
                </div>}
              </div>
              <div className="row" style={{ padding: "5px 10px" }}>
                {GetField("searchTruckConfig")["isVisible"] && <div className="col-md-2 MSTree">
                  <label className="control-label">{GetField("searchTruckConfig")["label"]}</label>
                  <MultiSelectTreeEditor name={"truckconfig"} data={truckConfigsTreeData} value={truckConfigsValue} dataItemKey={dataItemKey} checkField={checkField} size="large" onChange={TruckConfigChanged} textField="name" dataItemKey="id" filterable={true} onFilterChange={truckConfigChanged} placeholder="Select truck configuration" />
                </div>}
                {GetField("searchDirection")["isVisible"] && <div className="col-md-2">
                  <label className="control-label">{GetField("searchDirection")["label"]}</label>
                  <DropDownList
                    id="Direction"
                    data={directions}
                    value={direction}
                    onChange={directionChanged}
                    defaultItem="Select direction"
                  />
                </div>}
                {GetField("searchStatus")["isVisible"] && <div className="col-md-2">
                    <label className="control-label">{GetField("searchStatus")["label"]}</label>
                    <DropDownList
                        id="TruckTrailer"
                        data={statii}
                        value={status}
                        onChange={statusChanged}
                        defaultItem="Select status"
                    />
                </div>}
                {GetField("searchTruckTrailer")["isVisible"] && <div className="col-md-2">
                    <label className="control-label">{GetField("searchTruckTrailer")["label"]}</label>
                    <DropDownList
                        id="TruckTrailer"
                        data={truckTrailers}
                        value={truckTrailer}
                        onChange={truckTrailerChanged}
                        defaultItem="Select truck trailer"
                    />
                </div>}
                {GetField("searchTagId")["isVisible"] && <div className="col-md-2">
                    <label className="control-label">{GetField("searchTagId")["label"]}</label>
                    <TextBox id="TagId" type="text" value={tagId} onChange={(event) => setTagId(event.target.value)} placeholder="Enter tag ID" />
                </div>}                             
             </div>
            <div className="row" style={{ padding: "5px 10px" }}>
                {GetField("searchFleet")["isVisible"] && <div className="col-md-2">
                    <label className="control-label">{GetField("searchFleet")["label"]}</label>
                    <TextBox id="Fleet" type="text" value={fleet} onChange={(event) => setFleet(event.target.value)} placeholder="Enter fleet" />
                </div>}
            </div>
                         
              <div className="row" style={{ padding: "10px" }}>
                <div className="col-md-5"></div>
                <div className="col-md-3">
                  <Button onClick={DoSearch} themeColor="primary" icon="search">
                    Search
                  </Button>{" "}
                  <Button onClick={ClearSearch} icon="reset">
                    Clear
                  </Button>
                </div>
              </div>
            </ExpansionPanelContent>
          )}
        </Reveal>
      </ExpansionPanel>}
      {columns && permissions && <DataGrid
        dataSource="apiv7/trucks"
        params={lookupParams}
        columns={columns}
        permissions={permissions}
        update={forceUpdate}
        bulkStatus={BulkStatus}
        subTotals={subTotals}
        keyField="truckId"
      />}
    </div>
  );
};
export default Trucks;



